import api from "./axiosConfig"


export const signup = async (data: any) => {
  try {
    const response = await api.post("auth/signup", data);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};
export const verifyOtp = async (data: { email: string; otp: string }) => {
  try {
    const response = await api.post("auth/verify-otp", data);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const resendOtp = async (data: { email: string }) => {
  try {
    const response = await api.post("auth/resend-otp", data);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const forgotPassword = async (data: { email: string }) => {
  try {
    const response = await api.post("auth/forgot-password", data);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const verifyResetToken = async (token: string) => {
  try {
    const response = await api.get(`auth/verify-reset-token?token=${encodeURIComponent(token)}`);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const resetPassword = async (data: { token: string; password: string; password_confirmation: string }) => {
  try {
    const response = await api.post("auth/reset-password", data);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getVendeurProfil = async () => {
  try {
    const response = await api.get("vendeur/profil");
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const updateVendeurProfil = async (data: {
  prenom: string;
  nom: string;
  specialite?: string | null;
  telephone: string;
  adresse?: string | null;
  biographie?: string | null;
}) => {
  try {
    const response = await api.put("vendeur/profil", data);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const updateVendeurBoutique = async (data: {
  nom: string;
  description: string;
  adresse: string;
}) => {
  try {
    const response = await api.put("vendeur/boutique", data);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const updateVendeurPassword = async (data: {
  current: string;
  newPass: string;
  confirm: string;
}) => {
  try {
    const response = await api.put("vendeur/password", data);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getAcheteurProfil = async () => {
  try {
    const response = await api.get("acheteur/profil");
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const updateAcheteurProfil = async (data: {
  prenom: string;
  nom: string;
  telephone: string;
}) => {
  try {
    const response = await api.put("acheteur/profil", data);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const updateAcheteurPassword = async (data: {
  current: string;
  newPass: string;
  confirm: string;
}) => {
  try {
    const response = await api.put("acheteur/password", data);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getVendeurCommandes = async () => {
  try {
    const response = await api.get("vendeur/commandes");
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getVendeurCommande = async (id: number | string) => {
  try {
    const response = await api.get(`vendeur/commandes/${id}`);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const changerStatutVendeurCommande = async (
  id: number | string,
  data: { statut: string; numero_suivi?: string },
) => {
  try {
    const response = await api.put(`vendeur/commandes/${id}/statut`, data);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getVendeurProduits = async () => {
  try {
    const response = await api.get("vendeur/produits");
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getVendeurProduit = async (id: number | string) => {
  try {
    const response = await api.get(`vendeur/produits/${id}`);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

// Content-Type doit etre supprime (pas force a multipart/form-data) pour que le
// navigateur genere lui-meme le boundary. L'instance axios a un defaut
// application/json qui, sinon, ferait serialiser le FormData en JSON au lieu
// de l'envoyer en vrai multipart, et Laravel recevrait des champs images vides.
const multipartConfig = { headers: { "Content-Type": undefined } };

export const createVendeurProduit = async (formData: FormData) => {
  try {
    const response = await api.post("vendeur/produits", formData, multipartConfig);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const updateVendeurProduit = async (id: number | string, formData: FormData) => {
  try {
    const response = await api.post(`vendeur/produits/${id}`, formData, multipartConfig);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const deleteVendeurProduit = async (id: number | string) => {
  try {
    const response = await api.delete(`vendeur/produits/${id}`);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getVendeurProduitsArchives = async () => {
  try {
    const response = await api.get("vendeur/produits/archives");
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const restaurerVendeurProduit = async (id: number | string) => {
  try {
    const response = await api.patch(`vendeur/produits/${id}/restaurer`);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const updateVendeurProfilPhoto = async (formData: FormData) => {
  try {
    const response = await api.post("vendeur/profil/photo", formData, multipartConfig);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getVisiteurArtisans = async () => {
  try {
    const response = await api.get("visiteur/artisans");
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getVisiteurProduits = async () => {
  try {
    const response = await api.get("visiteur/produits");
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getVisiteurArtisan = async (slug: string) => {
  try {
    const response = await api.get(`visiteur/artisans/${slug}`);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getVisiteurProduit = async (slug: string) => {
  try {
    const response = await api.get(`visiteur/produits/${slug}`);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const incrementerVueProduit = async (id: number | string) => {
  try {
    const response = await api.post(`visiteur/produits/${id}/vue`);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const incrementerClicWhatsappProduit = async (id: number | string) => {
  try {
    const response = await api.post(`visiteur/produits/${id}/whatsapp-clic`);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getAdminProduits = async () => {
  try {
    const response = await api.get("admin/produits");
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const approuverAdminProduit = async (id: number | string) => {
  try {
    const response = await api.patch(`admin/produits/${id}/approuver`);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const refuserAdminProduit = async (id: number | string, motifRejet?: string) => {
  try {
    const response = await api.patch(`admin/produits/${id}/refuser`, { motif_rejet: motifRejet });
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const updateAdminProduitBadges = async (id: number | string, badges: string[]) => {
  try {
    const response = await api.patch(`admin/produits/${id}/badges`, { badges });
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const updateAdminProduit = async (id: number | string, formData: FormData) => {
  try {
    const response = await api.post(`admin/produits/${id}`, formData, multipartConfig);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getAdminAvis = async (productId?: number | string) => {
  try {
    const query = productId ? `?product_id=${productId}` : '';
    const response = await api.get(`admin/avis${query}`);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const deleteAdminAvis = async (id: number | string) => {
  try {
    const response = await api.delete(`admin/avis/${id}`);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getAdminCommandes = async () => {
  try {
    const response = await api.get("admin/commandes");
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getAdminCommande = async (id: number | string) => {
  try {
    const response = await api.get(`admin/commandes/${id}`);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const changerStatutAdminCommande = async (
  id: number | string,
  data: { statut: string; numero_suivi?: string },
) => {
  try {
    const response = await api.put(`admin/commandes/${id}/statut`, data);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getAdminArtisans = async () => {
  try {
    const response = await api.get("admin/artisans");
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const createAdminArtisan = async (data: {
  prenom: string;
  nom: string;
  email: string;
  telephone: string;
  specialite: string;
  boutique_nom: string;
  password?: string;
}) => {
  try {
    const response = await api.post("admin/artisans", data);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const suspendreAdminArtisan = async (id: number | string, motif?: string) => {
  try {
    const response = await api.patch(`admin/artisans/${id}/suspendre`, motif ? { motif } : undefined);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const certifierAdminArtisan = async (id: number | string) => {
  try {
    const response = await api.patch(`admin/artisans/${id}/certifier`);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getPanier = async () => {
  try {
    const response = await api.get("panier");
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const ajouterAuPanier = async (data: { product_id: number; quantite?: number }) => {
  try {
    const response = await api.post("panier/ajouter", data);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const modifierQuantitePanier = async (ligneId: number, quantite: number) => {
  try {
    const response = await api.put(`panier/produit/${ligneId}`, { quantite });
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const supprimerProduitPanier = async (ligneId: number) => {
  try {
    const response = await api.delete(`panier/produit/${ligneId}`);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const viderPanier = async () => {
  try {
    const response = await api.delete("panier/produit");
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getAdminStatistiques = async (mois: number = 6) => {
  try {
    const response = await api.get(`admin/statistiques?mois=${mois}`);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getVendeurMiseEnAvantHistorique = async () => {
  try {
    const response = await api.get("vendeur/mise-en-avant");
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const demanderVendeurMiseEnAvant = async (data: { product_id: number; message: string }) => {
  try {
    const response = await api.post("vendeur/mise-en-avant", data);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const checkoutCommande = async (data: {
  ville_livraison: string;
  quartier_livraison?: string;
  reperes_livraison?: string;
  telephone_livraison: string;
}) => {
  try {
    const response = await api.post("checkout", data);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getMesCommandes = async () => {
  try {
    const response = await api.get("mes-commandes");
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getMaCommande = async (id: number | string) => {
  try {
    const response = await api.get(`mes-commandes/${id}`);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const annulerMaCommande = async (id: number | string) => {
  try {
    const response = await api.patch(`mes-commandes/${id}/annuler`);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getAdminLogs = async (page: number = 1, action?: string) => {
  try {
    const query = action ? `?page=${page}&action=${action}` : `?page=${page}`;
    const response = await api.get(`admin/logs${query}`);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getAdminMisesEnAvant = async (page: number = 1) => {
  try {
    const response = await api.get(`admin/mises-en-avant?page=${page}`);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const approuverAdminMiseEnAvant = async (id: number | string) => {
  try {
    const response = await api.patch(`admin/mises-en-avant/${id}/approuver`);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const rejeterAdminMiseEnAvant = async (id: number | string) => {
  try {
    const response = await api.patch(`admin/mises-en-avant/${id}/rejeter`);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getAdminAcheteurs = async () => {
  try {
    const response = await api.get("admin/acheteurs");
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const suspendreAdminAcheteur = async (id: number | string, motif?: string) => {
  try {
    const response = await api.patch(`admin/acheteurs/${id}/suspendre`, motif ? { motif } : undefined);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const accorderAccesArtisan = async (id: number | string) => {
  try {
    const response = await api.patch(`admin/artisans/${id}/accorder-acces`);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const login = async (data: { email: string; password: string }) => {
  try {
    const response = await api.post("auth/login", {
      email: data.email,
      password: data.password,
    });

    return response.data; // message, user, token
  } catch (error: any) {
    throw error;
  }
};

export const logoutApi = async () => {
  try {
    const response = await api.post("auth/logout");
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const googleLogin = async (idToken: string) => {
  try {
    const response = await api.post("auth/google", { id_token: idToken });
    return response.data; // message, user, token
  } catch (error: any) {
    throw error;
  }
};

export const setup2FA = async () => {
  try {
    const response = await api.post("auth/2fa/setup");
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const confirm2FA = async (code: string) => {
  try {
    const response = await api.post("auth/2fa/confirm", { code });
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const verify2FA = async (tempToken: string, code: string) => {
  try {
    const response = await api.post("auth/2fa/verify", { temp_token: tempToken, code });
    return response.data; // message, user, token
  } catch (error: any) {
    throw error;
  }
};

export const getConnexionLogs = async (code: string, page: number = 1) => {
  try {
    const response = await api.get(`admin/utilisateurs/${code}/connexions?page=${page}`);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getProduitAvis = async (id: number | string) => {
  try {
    const response = await api.get(`visiteur/produits/${id}/avis`);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const creerProduitAvis = async (
  id: number | string,
  data: { nom_affiche: string; note: number; commentaire: string },
) => {
  try {
    const response = await api.post(`visiteur/produits/${id}/avis`, data);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getTemoignages = async () => {
  try {
    const response = await api.get("visiteur/temoignages");
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const creerTemoignage = async (data: { nom_affiche: string; commentaire: string }) => {
  try {
    const response = await api.post("temoignages", data);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getAdminTemoignages = async (statut?: string) => {
  try {
    const response = await api.get(`admin/temoignages${statut ? `?statut=${statut}` : ''}`);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const approuverAdminTemoignage = async (id: number | string) => {
  try {
    const response = await api.patch(`admin/temoignages/${id}/approuver`);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const rejeterAdminTemoignage = async (id: number | string) => {
  try {
    const response = await api.patch(`admin/temoignages/${id}/refuser`);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getParametres = async () => {
  try {
    const response = await api.get("parametres");
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const updateAdminParametres = async (data: {
  nom_site: string;
  devise: string;
  telephone: string;
  email: string;
  ville: string;
  adresse: string;
  horaires: string;
  instagram_url?: string | null;
  facebook_url?: string | null;
  twitter_url?: string | null;
}) => {
  try {
    const response = await api.put("admin/parametres", data);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const updateAdminParametreLogo = async (formData: FormData) => {
  try {
    const response = await api.post("admin/parametres/logo", formData, multipartConfig);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getLivraisonZones = async () => {
  try {
    const response = await api.get("livraison/zones");
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getTarifLivraison = async (ville: string) => {
  try {
    const response = await api.get(`livraison/tarif?ville=${encodeURIComponent(ville)}`);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getAdminZonesLivraison = async () => {
  try {
    const response = await api.get("admin/zones-livraison");
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const createAdminZoneLivraison = async (data: {
  nom: string;
  villes: string[];
  prix_base: number;
  delai_estime: string;
  actif: boolean;
}) => {
  try {
    const response = await api.post("admin/zones-livraison", data);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const updateAdminZoneLivraison = async (
  id: number | string,
  data: { nom: string; villes: string[]; prix_base: number; delai_estime: string; actif: boolean },
) => {
  try {
    const response = await api.put(`admin/zones-livraison/${id}`, data);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const deleteAdminZoneLivraison = async (id: number | string) => {
  try {
    const response = await api.delete(`admin/zones-livraison/${id}`);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getArtisanAvis = async (slug: string) => {
  try {
    const response = await api.get(`visiteur/artisans/${slug}/avis`);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const creerArtisanAvis = async (
  slug: string,
  data: { nom_affiche: string; note: number; commentaire: string },
) => {
  try {
    const response = await api.post(`visiteur/artisans/${slug}/avis`, data);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getAdminAvisArtisans = async () => {
  try {
    const response = await api.get('admin/avis-artisans');
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const deleteAdminAvisArtisan = async (id: number | string) => {
  try {
    const response = await api.delete(`admin/avis-artisans/${id}`);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

interface PushSubscriptionPayload {
  endpoint?: string;
  keys?: { p256dh?: string; auth?: string };
}

export const subscribePush = async (subscription: PushSubscriptionPayload) => {
  try {
    const response = await api.post("push/subscribe", subscription);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const unsubscribePush = async (endpoint: string) => {
  try {
    const response = await api.post("push/unsubscribe", { endpoint });
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getNotifications = async (page: number = 1) => {
  try {
    const response = await api.get(`notifications?page=${page}`);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const markNotificationLue = async (id: number | string) => {
  try {
    const response = await api.put(`notifications/${id}/lu`);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const markAllNotificationsLues = async () => {
  try {
    const response = await api.put("notifications/lu");
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getAdminSuggestionsLivraison = async () => {
  try {
    const response = await api.get("admin/suggestions-livraison");
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const promouvoirSuggestionLivraison = async (
  id: number | string,
  data: { nom: string; prix_base: number; delai_estime: string },
) => {
  try {
    const response = await api.post(`admin/suggestions-livraison/${id}/promouvoir`, data);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const ignorerSuggestionLivraison = async (id: number | string) => {
  try {
    const response = await api.delete(`admin/suggestions-livraison/${id}`);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};







